/**
 * Query Helper
 * [2.12 FIX] URLSearchParams manuel append zincirini ortadan kaldıran yardımcı.
 * Undefined, null ve boş string değerleri otomatik olarak atlar.
 */

export const toSearchParams = (obj: Record<string, unknown>): URLSearchParams => {
  const params = new URLSearchParams();
  Object.entries(obj).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      params.append(key, String(value));
    }
  });
  return params;
};
